module.exports = __webpack_public_path__ + "static/media/15@1024w.01bb0c7c.jpg";